// Module
var code = "<span class=\"privacy-policy-btn\" ng-click=\"$ctrl.openPrivacyPolicy()\">{{$ctrl.websiteCode}} Privacy Policy</span>";
// Exports
export default code;